export const getDataRequest = [
	{
		KEY: 'drivers',
		PAGE_TITLE: 'Drivers',
		DIALOG_CREATE: {
			URL: '/drivers/getNew',
			TYPE: 'get'
		},
		DIALOG_UPDATE: {
			URL: '/drivers/',
			TYPE: 'get'
		},
		create: {
			URL: '/drivers/new',
			TYPE: 'post'
		},
		edit: {
			URL: '/drivers/update/',
			TYPE: 'post'
		}
	},
	{
		KEY: 'trucks',
		PAGE_TITLE: 'Trucks',
		DIALOG_CREATE: {
			URL: '/getCustomers',
			TYPE: 'post'
		},
		DIALOG_UPDATE: {
			URL: '/trucks/getDriverTrailers',
			TYPE: 'post'
		},
		create: {
			URL: '/trucks/new',
			TYPE: 'post'
		},
		edit: {
			URL: '/trucks/update/',
			TYPE: 'post'
		}
	},
	{
		KEY: 'trailers',
		PAGE_TITLE: 'Trailers',
		DIALOG_CREATE: {
			URL: '/trailers/getTrailerInfo',
			TYPE: 'post'
		},
		DIALOG_UPDATE: {
			URL: '/trailers/',
			TYPE: 'get'
		},
		create: {
			URL: '/trailers/new',
			TYPE: 'post'
		},
		edit: {
			URL: '/trailers/update/',
			TYPE: 'post'
		}
	},
	{
		KEY: 'customers',
		PAGE_TITLE: 'Customers',
		DIALOG_CREATE: {
			URL: '/customers/new',
			TYPE: 'get'
		},
		DIALOG_UPDATE: {
			URL: '/customers/',
			TYPE: 'get'
		},
		create: {
			URL: '/customers/new',
			TYPE: 'post'
		},
		edit: {
			URL: '/customers/update/',
			TYPE: 'post'
		}
	},
	{
		KEY: 'employees',
		PAGE_TITLE: 'Employees',
		DIALOG_CREATE: {
			URL: '/employees/create',
			TYPE: 'get'
		},
		DIALOG_UPDATE: {
			URL: '/employees/',
			TYPE: 'get'
		},
		create: {
			URL: '/employees',
			TYPE: 'post'
		},
		edit: {
			URL: '/employees/',
			TYPE: 'put'
		}
	},
];
